import { RAISE_API_V1_URL } from "constants/endpoints";
import { deleteMethod, get, post } from "services/api";
import { freshDevice, prepareRiskRequest } from "services/sardine";

const deviceForRisk = (device, sessionId) => {
  const next = freshDevice(device);
  if (sessionId) next.session_id = sessionId;
  return next;
};

const CHECKOUT_URL = `${RAISE_API_V1_URL}/checkout`;
const CHECKOUT_POINTS_URL = `${RAISE_API_V1_URL}/checkout/points`;
const CHECKOUT_PAYMENT_METHODS_URL = `${RAISE_API_V1_URL}/payment_methods`;

export const checkout = async ({
  selectedPayment: payment_method_uuid,
  device
}) => {
  const risk = await prepareRiskRequest("checkout");
  const body = {
    payment_method_uuid,
    device: deviceForRisk(device, risk.sessionId)
  };

  return await post(CHECKOUT_URL, body);
};

export const getCheckoutData = async (removePoints = false) => {
  const response = await get(
    `${CHECKOUT_URL}/?${removePoints ? "apply_points=false" : ""}`
  );

  return response.data;
};

export const getDeviceIp = async () => {
  const URL = "https://api.ipify.org?format=json";
  const response = await get(URL);

  return response.data;
};

export const getPaymentMethods = async () => {
  const response = await get(CHECKOUT_PAYMENT_METHODS_URL);

  return response.data;
};

export const savePaymentMethod = async ({ paymentMethod: body }) => {
  const response = await post(CHECKOUT_PAYMENT_METHODS_URL, body);

  return response.data;
};

export const applyPoints = async ({
  selectedPayment: payment_method_uuid,
  device
}) => {
  const risk = await prepareRiskRequest("apply_points");
  const body = {
    payment_method_uuid,
    device: deviceForRisk(device, risk.sessionId),
    points: "true"
  };
  const response = await post(CHECKOUT_POINTS_URL, body);

  return response.data;
};

export const removePoints = async () => {
  const response = await deleteMethod(CHECKOUT_POINTS_URL);

  return response.data;
};
